import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import locales from './locales';
import config from './environments/index';

const AVAILABLE_LANGUAGES = {
  es: `${config.assetsEndpoint}imgs/flags/flag_sp.png`,
  fr: `${config.assetsEndpoint}imgs/flags/flag_fr.png`,
  en: `${config.assetsEndpoint}imgs/flags/flag_uk.png`,
  it: `${config.assetsEndpoint}imgs/flags/flag_it.png`,
  pt: `${config.assetsEndpoint}imgs/flags/flag_pt.png`,
};

class LanguageModal extends Component {
  getLangButtons() {
    const buttons = [];

    Object.keys(AVAILABLE_LANGUAGES).forEach((key, index) => {
      buttons.push(this.buildLangButton(key, index));
    });

    return buttons;
  }

  buildLangButton(currentLang, index) {
    const { lang, onChangeLanguage } = this.props;
    const t = locales(lang);

    return (
      <button
        key={index}
        type="button"
        className={`language-selector__item ${lang === currentLang ? 'is-selected' : ''}`}
        value={currentLang}
        onClick={() => onChangeLanguage(currentLang)}
      >
        <img alt={t(`changeLanguage.${currentLang}`)} src={AVAILABLE_LANGUAGES[currentLang]} />
        <span>{t(`changeLanguage.${currentLang}`)}</span>
      </button>
    );
  }

  render() {
    const langButtons = this.getLangButtons();
    const { onClose, lang } = this.props;
    const t = locales(lang);

    return (
      <div className={'language--modal__wrapper'}>
        <div className={'language--modal__header'}>
          <div className={'md__modal__header__close__wrapper'}>
            <button type="button" className={'close'} onClick={onClose}>
              <i className="ri-close-line" />
            </button>
          </div>
          <div>
            <h2>{t('changeLanguage.title')}</h2>
          </div>
        </div>
        <div className={'language--modal__body'}>
          <div className={'language-selector'}>
            {langButtons.map((button, index) => (
              <Fragment key={index}>{button}</Fragment>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

LanguageModal.propTypes = {
  lang: PropTypes.string.isRequired,
  onChangeLanguage: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LanguageModal;
